const Index = () => {

    const cards = [
    {
      id: 1,
      image: "/assets/images/systemRegister.jpg",
      title: "Gestão de clientes.",
      description: "Sistema de gestão de clientes, cadastros, históricos, documentos, reembolsos."
    },
    {
      id: 2,
      image: "/assets/images/systemRegister_product2.jpg",
      title: "Gestão de pacientes",
      description: "Sistema para clínica, cadastros, históricos, documentos, convênios, agendamento, acompanhamentos e retornos."
    },
    {
      id: 3,
      image: "/assets/images/systemRegister_product3.jpg",
      title: "CRM de Seguradora",
      description: "Sistema de gestão de clientes, cadastros, históricos, documentos, convênios, agendamento, acompanhamentos.."
    },
    {
      id: 4,
      image: "/assets/images/systemRegister_product4.jpg",
      title: "Controle de equipamentos",
      description: "Sistema de gestão de equipamentos para construtora de grande porte, cadastros, históricos, agendamento."
    },
    {
      id: 5,
      image: "/assets/images/systemRegister_product5.jpg",
      title: "Concessionária de veículos",
      description: "Sistema de gestão para rede de concessionária, cadastros, históricos, agendamento, vendas."
    },
     {
      id: 6,
      image: "/assets/images/systemRegister_product6.jpg",
      title: "Autopeças",
      description: "Sistema de gestão para loja de autopeças, cadastros, históricos, vendas, relatórios e inventários."
    },
     {
      id: 7,
      image: "/assets/images/systemRegister_product7.jpg",
      title: "Hidroelétrica",
      description: "Sistema de gestão para controle de serviços, cadastros, históricos, relatórios e inventários."
    },
     {
      id: 8,
      image: "/assets/images/systemRegister_product8.jpg",
      title: "Migração de planilhas",
      description: "Sistema de gestão de equipamentos para construtora de grande porte, cadastros, históricos, agendamento."
    },
     {
      id: 9,
      image: "/assets/images/systemRegister_product9.jpg",
      title: "Recursos Humanos",
      description: "Sistema de gestão para pequenas e médias empresas, cadastros, históricos, relatórios e inventários."
    },

     {
      id: 10,
      image: "/assets/images/systemRegister_product10.jpg",
      title: "Integração de serviços",
      description: "Integração com APi disponibilizadas pelo tribunal de justiça, trabalho feito para um escritório de advocacia."
    },

     {
      id: 11,
      image: "/assets/images/systemRegister_product11.jpg",
      title: "Implementação Mobile",
      description: "Modernizamos o CRM do cliente para smartphones e tablet, mobilidade para funcionários em campo."
    },

     {
      id: 12,
      image: "/assets/images/systemRegister_product12.jpg",
      title: "Migração",
      description: "Migramos um antiquado CRM para versão web, agora moderna, confiável e responsiva."
    },

     {
      id: 13,
      image: "/assets/images/systemRegister_product13.jpg",
      title: "Análises de qualidade",
      description: "Agora os técnicos em campo, mandam os dados de medições diretamente para o laboratório."
    },
    {
      id: 14,
      image: "/assets/images/systemRegister_product14.jpg",
      title: "Bet e esportes",
      description: "Atualizamos todas as consultas de api da betfair, mais rapidez e segurança."
    },

     {
      id: 15,
      image: "/assets/images/systemRegister_product15.jpg",
      title: "ECommerce",
      description: "Atualizamos todas as consultas de api do mercado livre, mais rapidez e segurança."
    }
  ];


return(
    <div>
    <div className="modern-jumbotron">
      <div className="jumbotron-content">
        <div className="text-content">
          <div className="badge">Somos entusiastas da tecnologia</div>
          <h1 className="jumbotron-title">Olá! Seja bem-vindo a <span className="brand-highlight">SpecsBR</span></h1>
          <p className="jumbotron-lead">Somos uma empresa de tecnologia especializada no desenvolvimento de sistemas para os negócios, soluções sob medida para você.</p>
          <p className="jumbotron-subtitle">Logo abaixo você pode explorar nosso diretório de produtos e serviços, todos eles podem ser customizados à sua necessidade, consulte nossos especialistas.</p>
          
          <div className="cta-container">
            <button className="cta-button-primary">
              <i className="fas fa-chart-line"></i>
              <span>Mais informações</span>
            </button>
           
          </div>
        </div>
        
        <div className="visual-content">
          <div className="tech-illustration">
            <div className="code-window">
              <div className="window-header">
                <div className="window-dots">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </div>
              <div className="code-content">
                <div className="code-line"></div>
                <div className="code-line short"></div>
                <div className="code-line"></div>
                <div className="code-line short"></div>
                <div className="code-line"></div>
              </div>
            </div>
            <div className="floating-shape shape-1"></div>
            <div className="floating-shape shape-2"></div>
            <div className="floating-shape shape-3"></div>
          </div>
        </div>
      </div>
    </div>

    <div className="content">
      <div className="container_cards">
        {cards.map(card => (
          <div key={card.id} className="card">
            <img src={card.image} alt={card.title} />
            <hr/>
            <span className="card_title">{card.title}</span>
            <p>{card.description}</p>
            <button type="button" className="demo-button">
              <i className="fas fa-eye"></i>
              Solicitar demo
            </button>
          </div>
        ))}
      </div>
    </div>
</div> //div wrap close
    
);
}

export default Index;